import React, { useState } from "react";
import Modal1 from "../DIsplay/Modal/Modal1";
import CommonFreeTextInput from "../common/inputs/CommonFreeTextInput";
import { MdDomain } from "react-icons/md";
import { useSelector } from "react-redux";
import setWhitelistDomain from "../../controllers/settings/whitelist/setWhitelistDomain";
import { enqueueSnackbar } from "notistack";

function AddWhitelistDomainModal({ open, setOpen, onSave }) {
  const { adminAuth } = useSelector((state) => state.user);
  const [domain, setDomain] = useState("");
  const [loading, setLoading] = useState(false);

  const isValid = !!String(domain || "").trim();

  const handleClose = () => {
    setDomain("");
    setOpen(false);
  };

  const handleSave = async () => {
    if (!isValid) return;
    setLoading(true);
    const res = await setWhitelistDomain(adminAuth, domain.trim()).finally(() =>
      setLoading(false)
    );
    if (res?.return) {
      const domains = res?.data || [];

      enqueueSnackbar("Domain successfully added to whitelist.", {
        variant: "success",
      });

      onSave?.(domains);
      handleClose();
    } else {
      enqueueSnackbar(
        res?.msg ||
          "Failed to add domain. Please check the domain and try again.",
        { variant: "error" }
      );
    }
  };

  return (
    <Modal1 open={open} setOpen={setOpen}>
      <div className="w-full max-w-md bg-white rounded-2xl p-5 flex flex-col gap-4">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <MdDomain className="text-primary text-xl" />
          </div>
          <div className="flex flex-col">
            <span className="font-semibold text-gray-900">
              Add whitelisted domain
            </span>
            <span className="text-sm text-gray-500">
              Enter a domain allowed to access admin features
            </span>
          </div>
        </div>

        {/* Input */}
        <CommonFreeTextInput
          className="w-full"
          placeholder="example.com"
          value={domain}
          onChange={(v) => setDomain(v)}
        />

        {/* Actions */}
        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 rounded-md bg-gray-100 font-semibold text-sm"
          >
            Cancel
          </button>

          <button
            type="button"
            disabled={!isValid}
            onClick={handleSave}
            className={`w-[120px] flex items-center justify-center h-[44px] px-5 py-2 rounded-md font-bold text-sm ${
              isValid
                ? "bg-primary1 text-white"
                : "bg-primary/10 text-primary cursor-not-allowed"
            }`}
          >
            {loading ? <div className="buttonLoader"></div> : <>Save</>}
          </button>
        </div>
      </div>
    </Modal1>
  );
}

export default AddWhitelistDomainModal;
